import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import TIM from 'tim-js-sdk';
export function translateGroupSystemNotice(message) {
  var groupName = message.payload.groupProfile.name || message.payload.groupProfile.groupID;

  switch (message.payload.operationType) {
    case 1:
      return "".concat(message.payload.operatorID, " \u7533\u8BF7\u52A0\u5165\u7FA4\u7EC4\uFF1A").concat(groupName);

    case 2:
      return "\u6210\u529F\u52A0\u5165\u7FA4\u7EC4\uFF1A".concat(groupName);

    case 3:
      return "\u7533\u8BF7\u52A0\u5165\u7FA4\u7EC4\uFF1A".concat(groupName, "\u88AB\u62D2\u7EDD");

    case 4:
      return "\u4F60\u88AB\u7BA1\u7406\u5458".concat(message.payload.operatorID, "\u8E22\u51FA\u7FA4\u7EC4\uFF1A").concat(groupName);

    case 5:
      return "\u7FA4\uFF1A".concat(groupName, " \u5DF2\u88AB").concat(message.payload.operatorID, "\u89E3\u6563");

    case 6:
      return "".concat(message.payload.operatorID, "\u521B\u5EFA\u7FA4\uFF1A").concat(groupName);

    case 7:
      return "".concat(message.payload.operatorID, "\u9080\u8BF7\u4F60\u52A0\u7FA4\uFF1A").concat(groupName);

    case 8:
      return "\u4F60\u9000\u51FA\u7FA4\u7EC4\uFF1A".concat(groupName);

    case 9:
      return "\u4F60\u88AB".concat(message.payload.operatorID, "\u8BBE\u7F6E\u4E3A\u7FA4\uFF1A").concat(groupName, "\u7684\u7BA1\u7406\u5458");

    case 10:
      return "\u4F60\u88AB".concat(message.payload.operatorID, "\u64A4\u9500\u7FA4\uFF1A").concat(groupName, "\u7684\u7BA1\u7406\u5458\u8EAB\u4EFD");

    case 255:
      return '自定义群系统通知: ' + message.payload.userDefinedField;
  }
}
export var errorMap = {
  500: '服务器错误',
  602: '用户名或密码不合法',
  610: '用户名格式错误',
  612: '用户已存在',
  620: '用户不存在',
  621: '密码错误'
};
export function filterCallingMessage(currentMessageList) {
  currentMessageList.forEach(function (item) {
    if (item.callType) {
      // 对于自己伪造的消息不需要解析
      return;
    }

    if (item.type === TIM.TYPES.MSG_MERGER && item.payload.downloadKey !== '') {
      var promise = window.tim.downloadMergerMessage(item);
      promise.then(function (imResponse) {
        // 下载成功后，SDK会更新 message.payload.messageList 等信息
        item = imResponse;
      }).catch(function (imError) {
        // 下载失败
        console.warn('downloadMergerMessage error:', imError);
      });
    }

    if (item.type === TIM.TYPES.MSG_CUSTOM) {
      var payloadData = {};

      try {
        payloadData = JSON.parse(item.payload.data);
      } catch (e) {
        payloadData = {};
      }

      if (payloadData.businessID === 1) {
        if (item.conversationType === TIM.TYPES.CONV_GROUP) {
          if (payloadData.actionType === 5) {
            item.nick = payloadData.inviteeList ? payloadData.inviteeList.join(',') : item.from;
          }

          var _text = window.trtcCalling.extractCallingInfoFromMessage(item);

          var group_text = "".concat(_text);
          item.type = TIM.TYPES.MSG_GRP_TIP;
          var customData = {
            operationType: 256,
            text: group_text,
            userIDList: []
          };
          item.payload = customData; // JSON.stringify(customData)
        }

        if (item.conversationType === TIM.TYPES.CONV_C2C) {
          var c2c_text = window.trtcCalling.extractCallingInfoFromMessage(item);
          var _customData = {
            text: c2c_text
          };
          item.payload = _customData; // JSON.stringify(customData)
        }
      }
    }
  });
}